module.exports = new __parcel__URL__("CSS.6030f5b7.png").toString();